import React, { useState } from 'react';
import { X, Check, Sparkles, Crown, Zap, Globe } from 'lucide-react';
import { useSubscription } from '../contexts/SubscriptionContext';

const UpgradeModal = ({ isOpen, onClose }) => {
    const { upgradeToPro } = useSubscription();
    const [processing, setProcessing] = useState(false);

    if (!isOpen) return null;

    const handleUpgrade = async () => {
        setProcessing(true);
        // Simulate processing delay
        setTimeout(async () => {
            const success = await upgradeToPro();
            if (success) {
                alert("Welcome to Pro! You now have unlimited power.");
                onClose();
            }
            setProcessing(false);
        }, 1500);
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden relative border-2 border-yellow-400">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-slate-400 hover:text-slate-600 transition-colors z-10"
                >
                    <X size={20} />
                </button>

                {/* Header */}
                <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-8 text-center relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-400 to-orange-500"></div>
                    <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
                        <Crown size={14} /> Premium Access
                    </div>
                    <h2 className="text-3xl font-extrabold text-slate-900 mb-2">Unlock Your Potential</h2>
                    <p className="text-slate-600">Get the tools you need to land your dream job.</p>
                </div>

                {/* Features */}
                <div className="p-8">
                    <ul className="space-y-4 mb-8">
                        <li className="flex items-start gap-3">
                            <div className="bg-green-100 p-1 rounded-full text-green-600 mt-0.5"><Check size={14} /></div>
                            <div>
                                <span className="font-bold text-slate-800">The Roaster</span>
                                <p className="text-slate-500 text-sm">Get brutal, actionable feedback to fix your resume.</p>
                            </div>
                        </li>
                        <li className="flex items-start gap-3">
                            <div className="bg-blue-100 p-1 rounded-full text-blue-600 mt-0.5"><Globe size={14} /></div>
                            <div>
                                <span className="font-bold text-slate-800">Global Translation</span>
                                <p className="text-slate-500 text-sm">Translate instantly into any language.</p>
                            </div>
                        </li>
                        <li className="flex items-start gap-3">
                            <div className="bg-purple-100 p-1 rounded-full text-purple-600 mt-0.5"><Zap size={14} /></div>
                            <div>
                                <span className="font-bold text-slate-800">Unlimited AI Writer</span>
                                <p className="text-slate-500 text-sm">Generate bullet points and summaries without limits.</p>
                            </div>
                        </li>
                    </ul>

                    {/* Price and Action */}
                    <div className="text-center">
                        <div className="mb-6">
                            <span className="text-4xl font-black text-slate-900">$9</span>
                            <span className="text-slate-500 font-medium">/month</span>
                        </div>

                        <button
                            onClick={handleUpgrade}
                            disabled={processing}
                            className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-white font-bold py-4 rounded-xl shadow-lg shadow-orange-500/25 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2"
                        >
                            {processing ? <span className="animate-pulse">Processing...</span> : (
                                <>
                                    <Sparkles size={18} /> Upgrade Now
                                </>
                            )}
                        </button>
                        <p className="text-xs text-slate-400 mt-4">Secure payment via Stripe. Cancel anytime.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpgradeModal;
